export default import.meta.ROLLUP_FILE_URL_BKEw1YxKSALV5R9D73GIpg